// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__zM6f6","productName":"Table_productName__vWuuC"};